import { createTelemetry } from '@reinz/telemetry/createTelemetry'

export const telemetry = createTelemetry({
  connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
  roleName: 'Companion web',
})
